import { Nav } from "../components/sections/Nav";
import { Hero } from "../components/sections/Hero";
import { WhatIsJyotish } from "../components/sections/WhatIsJyotish";
import { TropicalVsSidereal } from "../components/sections/TropicalVsSidereal";
import { WhyVedic } from "../components/sections/WhyVedic";
import { FAQ } from "../components/sections/FAQ";
import { Contact } from "../components/sections/Contact";
import { Footer } from "../components/sections/Footer";

export default function Home() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <WhatIsJyotish />
        <TropicalVsSidereal />
        <WhyVedic />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
